import { render, staticRenderFns } from "./easyCreate.vue?vue&type=template&id=565d9093&scoped=true"
import script from "./easyCreate.vue?vue&type=script&lang=js"
export * from "./easyCreate.vue?vue&type=script&lang=js"
import style0 from "./easyCreate.vue?vue&type=style&index=0&id=565d9093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d9093",
  null
  
)

export default component.exports